import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './components/Home';
import About from './components/About';
import Projects from './components/Projects';
import {getAbout, getProjects, getStories, getYtVideos, getPatients} from "./DataContent";
import Contact from "./components/Contact";
import Video from "./components/Video";

let appData = {
    selectedProjectIdx: 0,
    selectedYoutubeVid: 0,
    selectedPatient: 0,
    selectedStory: 0,
    projects: getProjects(),
    youtubeVideos: getYtVideos(),
    patients: getPatients(),
    stories: getStories(),
    about: getAbout(),
    isMobile: window.innerWidth <= 500
};

function App() {
        return (
            <Router>
                <div>
                    <Route exact path="/" component={() => <Home appData={appData}/>} />
                    <Route path="/about" component={() => <About appData={appData}/>} />
                    <Route path="/projects" component={()=> <Projects appData={appData}/>} />
                    <Route path="/contact" component={()=> <Contact appData={appData}/>} />
                    <Route path="/video" component={()=> <Video appData={appData}/>} />
                </div>
            </Router>
        );
}

export default App;
